import type React from "react";

type Props = {
    title?: React.ReactNode;
    /** Right side of the header, e.g. a citation chip. */
    right?: React.ReactNode;
    className?: string;
    children?: React.ReactNode;
};

export const PtV2Card: React.FC<Props> = ({title, right, className, children}) => (
    <section className={'ptv2-card' + (className ? ' ' + className : '')}>
        {(title || right) && <header className="ptv2-card-h">
            {title && <h3>{title}</h3>}
            {right}
        </header>}
        <div className="ptv2-card-b">{children}</div>
    </section>
);
